import { render, staticRenderFns } from "./Notepad.vue?vue&type=template&id=4b0b0708&scoped=true&"
import script from "./Notepad.vue?vue&type=script&lang=js&"
export * from "./Notepad.vue?vue&type=script&lang=js&"
import style0 from "./Notepad.vue?vue&type=style&index=0&id=4b0b0708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0b0708",
  null
  
)

export default component.exports